import type { IconProps } from '../lib/iconProps';

export const Steps = ({
  size = 24,
  width,
  height,
  color,
  title,
  className,
  style,
  ...props
}: IconProps): React.ReactElement => {
  const labelled = title != null || props['aria-label'] != null;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      height={height ?? size}
      width={width ?? size}
      fill="none"
      focusable="false"
      aria-hidden={labelled ? undefined : true}
      role={labelled ? 'img' : undefined}
      className={['whoop-icon', 'whoop-icon--mirror', className].filter(Boolean).join(' ')}
      style={
        color
          ? ({ '--whoop-icon-color': color, ...style } as React.CSSProperties)
          : style
      }
      {...props}
    >
      {title ? <title>{title}</title> : null}
      <path fill="currentColor" fillRule="evenodd" d="m12.063 5.148-.028.036a5 5 0 0 0-.29-.196c-.798-.506-1.806-.309-2.398.339l-6.746 7.236a4.53 4.53 0 0 0-.151 5.987l9.216 10.997.003.003a6.46 6.46 0 0 0 4.914 2.294h10.46a3.55 3.55 0 0 0 3.358-2.42l.052-.156v-.035a4.04 4.04 0 0 0-2.554-4.917 1 1 0 0 0-.09-.034l-3.29-1.058a2.34 2.34 0 0 1-1.345-1.447l-.007-.022L20.7 15.16c-.033-.109-.05-.28.148-.639v-.001l.723-1.295.005-.008c.49-.916.027-2.19-1.069-2.432l.02-.026.01-.011c.515-.648 1.71-2.137 2.686-3.351l.55-.685.002-.002c.405-.507.211-1.055.108-1.253a1.3 1.3 0 0 0-.233-.317 1.1 1.1 0 0 0-.501-.292c-3.413-.9-5.122-3.388-5.547-4.112a1.13 1.13 0 0 0-1.013-.579 1.18 1.18 0 0 0-.885.453h-.001zM21.18 22.15l-2.371-6.335-.007-.021c-.245-.753-.115-1.501.296-2.244l.002-.003.444-.796c-.794.062-1.566.324-2.416.612q-.316.108-.649.217c-1.091.355-2.555.756-3.843-.136l-.034-.002-.247-.216-.009-.007-.001-.002-.057-.05c-1.613-1.46-1.633-3.678-1.479-5.017l.001-.006q.024-.195.06-.387c.049-.317.107-.596.16-.82a3 3 0 0 0-.263-.2L7.268 10.49l-.023.026a2.52 2.52 0 0 0-.086 3.336l9.37 11.17a1 1 0 0 1-1.532 1.285l-9.37-11.17a4.5 4.5 0 0 1-.94-1.88l-.622.669a2.53 2.53 0 0 0-.082 3.34l9.213 10.993.002.001a4.46 4.46 0 0 0 3.405 1.584h10.44c.614 0 1.17-.369 1.415-.936l.045-.136a2.04 2.04 0 0 0-1.317-2.586l-3.118-1h-.003a4 4 0 0 1-.22-.078l-3.518-1.132a1 1 0 1 1 .612-1.904zM16.556 2.742 13.623 6.4a3.9 3.9 0 0 0-.782 1.697 7.5 7.5 0 0 0-.086 1.063c-.005 1.03.237 1.965.905 2.551.427.37.961.37 2.201-.033q.248-.08.529-.179c.569-.196 1.231-.424 1.947-.58l.077-.293c.102-.406.282-.788.56-1.129.484-.609 1.553-1.94 2.483-3.097a11.4 11.4 0 0 1-4.901-3.658" clipRule="evenodd"/>
    </svg>
  );
};
